import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {interval, Subscription} from 'rxjs';
import {Card} from '../../../card-container/card/card';
import {StudentService} from '../../../../../shared-components/student/student.service';
import {StudentSummaryService} from '../../../student-summary.service';
import {YearService} from '../../../../../shared-components/year/year.service';
import {CardStudentNotes} from './card-student-notes';
import {Router} from '@angular/router';

@Component({
    selector: 'app-student-notes-card',
    templateUrl: './student-notes-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./student-notes-card.component.css']
})
export class StudentNotesCardComponent implements OnInit, OnDestroy {

    @Input() data: any;
    subscriptions: Subscription[] = [];
    card: Card;
    studentNotes: CardStudentNotes[] = [];
    categories: string[] = [];

    constructor(
        private cdr: ChangeDetectorRef,
        private studentService: StudentService,
        private router: Router,
        private studentSummaryService: StudentSummaryService,
        private yearService: YearService
    ) {
    }

    ngOnInit() {
        this.card = this.data;
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getNotes();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    getNotes() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardStudentNotes(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier).subscribe((response) => {
            if (response.ok) {
                this.studentNotes = response.body;
                // Group by Definition (category)
                this.categories = this.studentNotes.map(note => note.Definition).filter((cat, pos) => {
                    return this.studentNotes.map(note => note.Definition).indexOf(cat) == pos;
                });
                this.updateView();
            }
        });
    }

    viewStudentNotesClick() {
        this.router.navigateByUrl('/classroom360/studentNotes?studentPortal=true');
    }

    updateView() {
        this.cdr.detectChanges();
    }

}
